<template>
  <div>
    <router-link to="promote" v-show="adShow">
      <img class="goTop1" style="width: 70px;height: 70px;  border-radius: 5px;"
        src="https://yunzhixuanpro.fw366.cn/static/api/bg/ad.png" />
    </router-link>
    <div v-if="activeShow" class="goTop" ref="goTop" @click="goTopClick">
      <i class="el-icon-caret-top"></i>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeShow: false,
        adShow: false
      };
    },
    mounted() {
      // if (localStorage.getItem('adShow') == true) {
      //   this.adShow = true
      // } else {
      //   this.adShow = false
      // }
    },
    methods: {
      goTopClick() {
        document.documentElement.scrollIntoView({
          behavior: "smooth"
        });
      },
      handleScroll() {
        let heightt = document.documentElement.scrollTop || document.body.scrollTop;
        if (heightt > 1000) {
          this.activeShow = true;
        } else {
          this.activeShow = false;
        }
      },
    },
    mounted() {
      //监听滚动条
      window.addEventListener("scroll", this.handleScroll, true);
    },
  };
</script>

<style lang="scss" scoped>
  .goTop1 {
    position: fixed;
    background-color: #fff;
    cursor: pointer;
    z-index: 5;
    right: 4%;
    bottom: 16%;

    -webkit-animation-name: scaleDraw;
    /*关键帧名称*/

    -webkit-animation-timing-function: ease-in-out;
    /*动画的速度曲线*/

    -webkit-animation-iteration-count: infinite;
    /*动画播放的次数*/

    -webkit-animation-duration: 2s;
    /*动画所花费的时间*/
  }

  .goTop {
    position: fixed;
    background-color: #fff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: #409eff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    box-shadow: 0 0 6px;
    cursor: pointer;
    z-index: 5;
    right: 5%;
    bottom: 10%;

    .img {
      width: 50px;
      height: 50px;
    }

    &:hover {
      background-color: #f2f6fc;
    }
  }

  @keyframes scaleDraw {
    /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/

    0% {

      transform: scale(1);
      /*开始为原始大小*/

    }

    25% {

      transform: scale(1.1);
      /*放大1.1倍*/

    }

    50% {

      transform: scale(1);

    }

    75% {

      transform: scale(1.1);

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/backTop.vue